var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelIcon12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 7.75054V12.2509M9.25 7.75054V12.2509M13 4.00024V14.5011C13 14.8989 12.842 15.2805 12.5607 15.5618C12.2794 15.8432 11.8978 16.0012 11.5 16.0012H4C3.60218 16.0012 3.22064 15.8432 2.93934 15.5618C2.65804 15.2805 2.5 14.8989 2.5 14.5011V4.00024M1 4.00024H14.5M4.75 4.00024V2.50012C4.75 2.10226 4.90804 1.7207 5.18934 1.43937C5.47064 1.15805 5.85218 1 6.25 1H9.25C9.64782 1 10.0294 1.15805 10.3107 1.43937C10.592 1.7207 10.75 2.10226 10.75 2.50012V4.00024",
    stroke: "#9CA3AF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelIcon12);
export default __webpack_public_path__ + "static/media/delIcon12.1fbdc71845313ccd693ab3058d0608f2.svg";
export { ForwardRef as ReactComponent };